import dayjs from 'dayjs';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';
import { IUser } from 'app/shared/model/user.model';

export interface IVehiclePosition {
  id?: number;
  created?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
  user?: IUser | null;
}

export const defaultValue: Readonly<IVehiclePosition> = {};
